/**
 * This component is used to show and edit the consulting fee for a project. (This is only for the finance team)
 */

import { updateConsultingFee } from "@/api/projects";
import { ProjectProps } from "@/interfaces/project_types";
import { useState, useEffect } from "react";
import { toast } from "sonner";

export function ConsultingFeeComp({project}: {project: ProjectProps}) {
    const [isEditing, setIsEditing] = useState(false)
    const [consultingFee, setConsultingFee] = useState(project.consulting_fee) // Number value
    const [inputValue, setInputValue] = useState(project.consulting_fee?.toString() || '') // String value for input
    const oldConsultingFee: number = project.consulting_fee || 0

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInputValue(value)
        setConsultingFee(Number(value))
    }

    const onSave = async() => {
        setIsEditing(false);

        if (project.project_id && consultingFee) {
            const status = await updateConsultingFee(project.project_id, consultingFee)

            if (status === 200) {
                toast.success("Consulting fee updated successfully")
                setConsultingFee(consultingFee)
            } else if (status === 400) {
                toast.error("Consulting fee must be greater than 0")
                setConsultingFee(oldConsultingFee)
            } else if (status === 403) {
                toast.error("You are not authorized to update the consulting fee")
                setConsultingFee(oldConsultingFee)
            } else {
                toast.error("Failed to update consulting fee")
                setConsultingFee(oldConsultingFee)
            }
        } else {
            console.error("Project ID or consulting fee is undefined")
            toast.error("Project ID or consulting fee is undefined") 
        }
    }

    const onCancel = () => {
        setIsEditing(false);
        setConsultingFee(oldConsultingFee)
        setInputValue(oldConsultingFee.toString())
    }

    // Update state when project prop changes
    // Used when the table updates
    useEffect(() => {
        setConsultingFee(project.consulting_fee)
        setInputValue(project.consulting_fee?.toString() || '')
    }, [project.consulting_fee])

    return (
        <div className="w-full">
            {isEditing ? (
                <div className="flex flex-row gap-2">
                    <input 
                        type="text" 
                        name="consulting_fee" 
                        value={inputValue}
                        onChange={onChange} 
                        className="w-full" 
                    />
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-md w-1/2" onClick={() => {
                        onSave()
                    } }>Save</button>
                    <button className="bg-red-500 text-white px-4 py-2 rounded-md w-1/2" onClick={() => {
                        onCancel()
                    } }>Cancel</button>
                </div>
            ) : (
                <div className="text-sm underline cursor-pointer" onClick={() => {
                    setIsEditing(true)
                }}>{consultingFee && Number(consultingFee) > 0 ? `$${consultingFee}` : "(Needs to be set)"}</div>
            )}
        </div>
    )
}